import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Googleapi {
  private apiLoaded = false;

  load(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.apiLoaded) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCTjRZZvi07lTR2dPIEyKO_8hRthj2SQGI&libraries=places';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.apiLoaded = true;
        resolve();
      };
      script.onerror = (err) => reject(err);
      document.head.appendChild(script);
    });
  }
}
